import type { Merger } from '#src/merge/mergers/merger.ts'

/**
 * Special merger for handling FHIR objects with `use` properties (e.g. addresses and names).
 * When objects with the same 'use' are found, we use the incoming object.
 */
export const useBasedArrayMerger: Merger = {
  canMerge: ({ current, incoming, key }) =>
    ['address', 'name'].includes(key) &&
    (Array.isArray(current) || Array.isArray(incoming)),
  merge: ({ current, incoming }) => {
    if (incoming === undefined || incoming === null) {
      return current
    }
    if (!Array.isArray(current) || !Array.isArray(incoming)) {
      return incoming
    }

    const merged = []
    const uniqueMerged = new Set()
    const incomingByUse = new Map(incoming.map((obj) => [obj.use, obj]))

    // First add all incoming objects (deduplicating exact matches)
    for (const obj of incoming) {
      const objString = JSON.stringify(obj)
      if (!uniqueMerged.has(objString)) {
        merged.push(obj)
        uniqueMerged.add(objString)
      }
    }

    // Then add any current objects that don't have a matching use in incoming
    for (const currentObj of current) {
      const currentObjString = JSON.stringify(currentObj)
      if (
        !incomingByUse.has(currentObj.use) &&
        !uniqueMerged.has(currentObjString)
      ) {
        merged.push(currentObj)
        uniqueMerged.add(currentObjString)
      }
    }

    return merged
  },
}
